import { ViewTpModel } from "@eco/client";
import { useEcoClient } from "hooks";
import { useCallback } from "react";
import useEcoMutation, { useEcoMutationOptions } from "./useEcoMutation";

/**
 * 
 * 
 * 
 */
export const useViewTpSaveOrUpdate = <TEntity, TData = unknown, TError=unknown>(
        config?: useEcoMutationOptions<TData, TError, ViewTpModel<TEntity>>
    ) => {

    const ecoClient = useEcoClient();

    const mutationFn = useCallback((variables: ViewTpModel<TEntity>): Promise<TData> => {
        return ecoClient.mutation<TEntity, TData>({
            type: 'REQUEST_SAVE_OR_UPDATE',
            viewTp: variables
        })
    }, [])
    
    return useEcoMutation<TData, ViewTpModel<TEntity>, TError>(mutationFn, config)
}
